
                  export default function (Component) {
                      Component.__source = "src/components/moduleCard.vue"
                  }
              